import { CanActivateFn, Routes } from '@angular/router';
import { LoginComponent } from './core/authentication/components/login/login.component';
import { PageConfig, PAGES_CONFIG } from './shared/page/page.config';
import { CodeComponent } from './core/authentication/components/code/code';
import { userLoggedInGuard } from './core/guards/user-logged-in-guard';
import { userIsEditorGuard } from './core/guards/user-is-editor-guard';
import { ROUTES } from './app.routes.constants';

function userIsEditorGuardForPageConfig(pageConfig: PageConfig): CanActivateFn {
  if (pageConfig.onlyEditor) return userIsEditorGuard();
  if (pageConfig.editorOnlyQueryParams) {
    return userIsEditorGuard({
      checkOnlyIfQueryParamsPresent: pageConfig.editorOnlyQueryParams,
    });
  }
  return () => true;
}

export const routes: Routes = [
  {
    path: ROUTES.login,
    component: LoginComponent,
  },
  {
    path: ROUTES.passportCode,
    component: CodeComponent,
  },
  {
    path: '',
    redirectTo:
      PAGES_CONFIG.find(({ pageName }) => pageName === ROUTES.defaultPage)
        ?.defaultUrl ?? '',
  },
  ...PAGES_CONFIG.map(pageConfig => ({
    path: pageConfig.defaultUrl,
    component: pageConfig.pageComponent,
    canActivate: [
      userLoggedInGuard,
      userIsEditorGuardForPageConfig(pageConfig),
    ],
  })),
];
